module.exports = __webpack_public_path__ + "b14c51198c557b7ce17adce29d4cefbb.pdf";